module.exports = __webpack_public_path__ + "img/spartan_logo.e6cb72a2.svg";